<template>
  <div class="input-container">
    <textarea
        ref="textarea"
        :value="value"
        placeholder="Include project details like square footage, number of rooms, type of materials, etc."
        rows="5"
        class="INPUT"
        maxlength="2048"
        selenium="notes-input"
        @input="$emit('input', $event.target.value)"
    />
  </div>
</template>

<script>
export default {
  name: 'notes',
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  methods: {
    focus () {
      this.$refs.textarea.focus();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools";
.INPUT {
  width: 100%;
  height: 100%;
  resize: none;
  margin-top:0px;
  padding:16px;
  &:focus-visible {
    outline-color: $color-depot;
  }
}
</style>
